import zhCN from './zh-CN';
import zhTW from './zh-TW';
import en from './en';
import { getLang } from '../base';

var index = {
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    'en': en
};

export function getAddrData() {
    return index[getLang()];
}

export default {
    getAddrData
}


// WEBPACK FOOTER //
// ./src/utils/addr/index.js